import { ShortcutsModal } from "@/components/shortcuts-modal";

interface AppLayoutDialogsProps {
  shortcutsOpen: () => boolean;
  setShortcutsOpen: (open: boolean) => void;
}

export function AppLayoutDialogs(props: AppLayoutDialogsProps) {
  return (
    <ShortcutsModal
      isOpen={props.shortcutsOpen()}
      onClose={() => {
        props.setShortcutsOpen(false);
      }}
    />
  );
}
